<div>
    <app-route-master-list></app-route-master-list>
</div>
<div>
    <app-route-master-form></app-route-master-form>
</div>